import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M3 21.4004V13.4004H5V18.0004L17.6 5.40039H13V3.40039H21V11.4004H19V6.80039L6.4 19.4004H11V21.4004H3Z" }, null, -1)
  ]))]))
}
export default { render: render }